import Vue from 'vue';
import Toasted from 'vue-toasted';

//import 'vue-toasted/dist/vue-toasted.min.css';
Vue.use(Toasted, { position: 'bottom-center', duration: 4000 });



Vue.mixin({
    methods: {
        showConfirmation(options) {
            return this.$bvModal.msgBoxConfirm(options.message, {
                title: this.$t('Confirmation'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'info',
                okTitle: this.$t('Yes'),
                cancelTitle: this.$t('No'),
                footerClass: 'p-2',
                hideHeader: true,
                noFade: true,
                hideHeaderClose: false,
                centered: true
            }).then(result => {
                
                if (result == true && options.callback != undefined) {
                    options.callback();
                }
            })
        },
        showConfirmationV2(options) {
            return this.$bvModal.msgBoxConfirm(options.message, {
                title: this.$t('Confirmation'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'info',
                okTitle: this.$t('Yes'),
                cancelTitle: this.$t('No'),
                footerClass: 'p-2',
                hideHeader: true,
                noFade: true,
                hideHeaderClose: false,
                centered: true
            }).then(result => {

                options.callback(result == null ? false : result);

            })
        },
        showInfoToast2(options) {
            this.$toasted.show(options.msg, {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 5000
            });
        },
        showInfoToast(options) {
            
            this.$toasted.info(options != undefined ? options.msg : this.$t('Saved successfully'))
        },
        showSuccessToast(options) {
            this.$toasted.success(options != undefined ? options.msg : this.$t('Saved successfully'))
        },
        showDeletionSuccessToast() {
            this.showSuccessToast({ msg: this.$t('Deleted successfully') })
        },
        showErrorToast(options) {
            this.$toasted.error(options != undefined ? options.msg : this.$t('Something went wrong!'));
        },
        showValidationErrorToast(options) {
            this.$toasted.error(options != undefined ? options.msg : this.$t('Data provided is invalid'));
        },
        showDeleteConfirmation(options,callback) {
           return this.$bvModal.msgBoxConfirm(this.$t('You are about to delete this item, continue?'), {
                title: this.$t('Confirmation'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.$t('Yes'),
                cancelTitle: this.$t('No'),
                footerClass: 'p-2',
                hideHeader: true,
                noFade: true,
                hideHeaderClose: false,
                centered: true
           }).then(result => {
               if (result) {
                   callback();
               }
           })
        }
    }
})
